
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3KmKC"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3KmKC", function(module, exports) {

let $2ba750d65e797d4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ba750d65e797d4c$var$load("h3ABO"),
    $2ba750d65e797d4c$var$load("9hYRW"),
    $2ba750d65e797d4c$var$load("kpm7S"),
    $2ba750d65e797d4c$var$load("5wC2D"),
    $2ba750d65e797d4c$var$load("2YffH"),
    $2ba750d65e797d4c$var$load("g7ggm"),
    $2ba750d65e797d4c$var$load("eEyVs"),
    $2ba750d65e797d4c$var$load("6mHrv"),
    $2ba750d65e797d4c$var$load("awWN9"),
    $2ba750d65e797d4c$var$load("9CYct"),
    $2ba750d65e797d4c$var$load("fP9Su"),
    $2ba750d65e797d4c$var$load("3KcX6"),
    $2ba750d65e797d4c$var$load("hZtKG"),
    $2ba750d65e797d4c$var$load("dkqvW"),
    $2ba750d65e797d4c$var$load("lVO3w"),
    $2ba750d65e797d4c$var$load("hyzoX"),
    $2ba750d65e797d4c$var$load("h9Ed7"),
    $2ba750d65e797d4c$var$load("eBRUf"),
    $2ba750d65e797d4c$var$load("kbRvk"),
    $2ba750d65e797d4c$var$load("tKhaz"),
    $2ba750d65e797d4c$var$load("hwT9D"),
    $2ba750d65e797d4c$var$load("j4Bpe"),
    $2ba750d65e797d4c$var$load("cD6Zr"),
    $2ba750d65e797d4c$var$load("k3jER"),
    $2ba750d65e797d4c$var$load("9wzNh"),
    $2ba750d65e797d4c$var$load("8YSo7"),
    $2ba750d65e797d4c$var$load("9ldRJ"),
    $2ba750d65e797d4c$var$load("50ame"),
    $2ba750d65e797d4c$var$load("7do1E"),
    $2ba750d65e797d4c$var$load("77dkW"),
    $2ba750d65e797d4c$var$load("1MlIV"),
    $2ba750d65e797d4c$var$load("6iz6l"),
    $2ba750d65e797d4c$var$load("4SCW2"),
    $2ba750d65e797d4c$var$load("aXHNO"),
    $2ba750d65e797d4c$var$load("kmvek"),
    $2ba750d65e797d4c$var$load("Wowvf"),
    $2ba750d65e797d4c$var$load("421lv"),
    $2ba750d65e797d4c$var$load("dek7I"),
    $2ba750d65e797d4c$var$load("3SmkN"),
    $2ba750d65e797d4c$var$load("dYtBN"),
    $2ba750d65e797d4c$var$load("kNV5Y"),
    $2ba750d65e797d4c$var$load("6wr18"),
    $2ba750d65e797d4c$var$load("kjZZD"),
    $2ba750d65e797d4c$var$load("7cDV0"),
    $2ba750d65e797d4c$var$load("ijD5W"),
    $2ba750d65e797d4c$var$load("3JSgG"),
    $2ba750d65e797d4c$var$load("37ldp"),
    $2ba750d65e797d4c$var$load("ffEVr"),
    $2ba750d65e797d4c$var$load("9AXkC"),
    $2ba750d65e797d4c$var$load("28arV"),
    $2ba750d65e797d4c$var$load("hhss7"),
    $2ba750d65e797d4c$var$load("l1BQC"),
    $2ba750d65e797d4c$var$load("jlSF3"),
    $2ba750d65e797d4c$var$load("dP7ao"),
    $2ba750d65e797d4c$var$load("hogcU"),
    $2ba750d65e797d4c$var$load("4pqtR"),
    $2ba750d65e797d4c$var$load("5XqRg"),
    $2ba750d65e797d4c$var$load("7EorR"),
    $2ba750d65e797d4c$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.349efe3e.js.map
